(function () {
  'use strict';

  /*
      Directive handles the display, config and activity logging of the card details button
      Attributes:
          name - string name of the card
          href - path to card details
          showLink - angular boolean (truthy/falsy) indicating if link should be displayed
          hasData - angular boolean (truthy/falsy) indicating if card has data to display (if missing, default = true)
   */
  /* Directives */
  angular.module('wsLrs.directives').directive('wsCardButton', [function wsCardButton() {
    return {
      restrict: 'A',
      replace: false,
      scope: {
        name: "@",
        href: "@",
        showLink: "=",
        hasData: "=?"
      },
      templateUrl: "modules/common/directives/card-button/card-button.html"
    };
  }]);
})();
